// Configuração central do GSAP. Importe sempre daqui para garantir que os plugins estão registrados.
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { useGSAP } from '@gsap/react'

gsap.registerPlugin(useGSAP, ScrollTrigger, SplitText)

gsap.defaults({ ease: 'power3.out', duration: 0.9 })
ScrollTrigger.config({ ignoreMobileResize: true })

// Atraso (em segundos) antes das animações de entrada da página.
// O PageTransition define esse valor: 0 ao abrir o site, e o tempo da cortina ao trocar de página.
export const transition = { delay: 0 }

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches

export { gsap, ScrollTrigger, SplitText, useGSAP }
